import { useCallback, useMemo, useState } from "react";
import useLocalStorage from "./LocalStorage";

const vapidPublicKey = 'BDTUmL4nGQnueWPp3A5bFgwvDXJg4lMxv1d-W9m-9lYNaTegEr2TbQefj6Kbe2-pcjsDmumm3a_bZMzVHLGpdSI';

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding) // eslint-disable-next-line
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}

export default function useServiceWorkerController(serviceWorkerConfigRef) {
    // more info at https://medium.com/toplyne-engineering/pwa-update-notifications-in-a-react-application-f5680d51bb2

    let [pushManager, setPushManager] = useState(undefined);
    let [waitingWorker, setWaitingWorker] = useState(undefined);
    let [updateIsReady, setUpdateIsReady] = useState(false);
    function swOnUpdate(registration) {
        setUpdateIsReady(true);
        setWaitingWorker(registration.waiting);
    }
    serviceWorkerConfigRef.onUpdate = swOnUpdate;

    let [state, setState] = useState(undefined); // "activated"
    function onChangeState(state) {
        setState(state);
    }
    serviceWorkerConfigRef.onChangeState = onChangeState;

    const reloadForUpdate = useCallback(() => {
        waitingWorker?.postMessage({ type: "SKIP_WAITING" });
        setUpdateIsReady(false);
        window.location.reload();
    }, [waitingWorker]);

    // const [pushSubscription, setPushSubscription] = useLocalStorage('pushSubscription', undefined);
    let [pushSubscription, setPushSubscription] = useState(undefined);

    function swOnGotRegistration(registration) {
        if (registration.pushManager !== undefined) {
            console.log("SW.swOnGotRegistration: start")
            registration.pushManager.getSubscription().then(function (subscription) {
                console.log("SW.swOnGotRegistration: checking push subscription")
                if (!subscription) {
                    console.log("SW.swOnGotRegistration: shouldAskPushPermission later")
                } else {
                    console.log("SW.swOnGotRegistration: we have a push subscription")
                    setPushSubscription(subscription)
                }
            }).catch(err => console.log(err));;
        } else {
            console.log("SW.swOnGotRegistration: registration.pushManager === undefined")
        }
        setPushManager(registration.pushManager);
    }
    serviceWorkerConfigRef.onGotRegistration = swOnGotRegistration;

    let [pushPermissionDenied, setPushPermissionDenied] = useLocalStorage("pushPermissionDenied", false);
    const askPushPermission = useCallback(() => {
        if (pushManager !== undefined) {
            console.log("SW.askPushPermission: let's subscribe")
            pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
            }).then(function (subscription) {
                console.log("SW.askPushPermission: got the subscription")
                setPushSubscription(subscription)
                setPushPermissionDenied(false);
            }).catch(err => {
                console.log(err)
                let errStr = String(err);
                if (errStr.includes("NotAllowedError") || errStr.includes("denied")) {
                    setPushPermissionDenied(true);
                }
            });
        } else {
            console.log("SW.askPushPermission: pushManager === undefined")
        }
    }, [pushManager, setPushPermissionDenied]);

    const shouldAskPushPermission =
        (pushManager !== undefined) &&
        (pushSubscription === undefined) &&
        (state === "activated") &&
        (!pushPermissionDenied);
    
    const pushSubscriptionStr = useMemo(() => {
        if (pushSubscription) {
            return JSON.stringify(pushSubscription);
        } else {
            return undefined
        }
    }, [pushSubscription])

    console.log("updateIsReady:", updateIsReady);
    console.log("pushPermissionDenied:", pushPermissionDenied);

    return {
        state,
        updateIsReady, reloadForUpdate,
        shouldAskPushPermission, askPushPermission, pushSubscription, pushSubscriptionStr, pushPermissionDenied
    }
}